import React from 'react';
import { FacilityCreateTemplate } from 'themes/application/facility/pages';
import { observer } from 'mobx-react';
import { FacilityCreateViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new FacilityCreateViewStore(rootStore), 'editView')
@observer
class FacilityCreate extends React.Component {
    render() {
        return <FacilityCreateTemplate {...this.props} />
    }
}

export default FacilityCreate;